export default __webpack_public_path__ + "static/media/home_background1.3ba81343.png";